<template>
  <div id="Manager" class="fullheight">
    <fe-table
      class="fullheight"
      @load="loadData"
      :data="budget_manager"
      :style="{height: maxHeight + 'px'}"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="f_corporate_no,f_company_name"
      :show-export="false"
      :show-custom-column="true"
      ref="htTable"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="showDialog()" type="primary"
            >添加</el-button
          >
          <fe-delete-button
            url="${portal}/system/tenant_corporate_info/"
            class="marginLeft16"
            :htTable="$refs.htTable"
            >删除</fe-delete-button
          >
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column
          prop="f_corporate_no"
          label="法人机构编号"
          :sortable="true"
          :sort-by="'f_corporate_no'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="f_company_name"
          label="公司名称"
          :sortable="true"
          :sort-by="'f_company_name'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="f_tax_no"
          label="税号"
          :sortable="true"
          :sort-by="'f_tax_no'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="F_company_tel"
          label="联系电话"
          :sortable="true"
          :sort-by="'F_company_tel'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="bank"
          label="开户银行"
          :sortable="true"
          :sort-by="'bank'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="F_bank_no"
          label="账号"
          :sortable="true"
          :sort-by="'F_bank_no'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="f_company_address"
          label="单位地址"
          :sortable="true"
          :sort-by="'f_company_address'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="f_corporate_person"
          label="法定代表人"
          :sortable="true"
          :sort-by="'f_corporate_person'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="f_default"
          label="是否默认"
          :sortable="true"
          :sort-by="'f_default'"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.f_default === 0">否</span>
            <span v-if="scope.row.f_default === 1">是</span>
          </template>
        </eco-table-column>
        <eco-table-column label="操作" width="150">
          <template v-slot="{ row }">
            <el-link
              type="primary"
              :underline="false" @click="showBillInfo(row)"
              >开票资料</el-link
            >
            <el-link
              type="primary"
              :underline="false" @click="showDialog(row.id)" class="marginLeft16">编辑</el-link>
          </template>
        </eco-table-column>
      </template>
    </fe-table>
    <el-dialog
      width="400px"
      :visible.sync="dialogBillVisible"
      :close-on-click-modal="true"
      appendToBody
    >
      <div class="companyName" slot="title">
        {{ model.company_name }}
      </div>
      <div class="bill">
        <!--        <div class="bill_content">-->
        <!--          <span>{{ model.company_name }}</span>-->
        <!--        </div>-->
        <div class="bill_content">
          <div>
            <div>税</div>
            <div>号</div>
          </div>
          <div>{{ model.tax_no }}</div>
        </div>
        <div class="bill_content">
          <div>
            <div>单</div>
            <div>位</div>
            <div>地</div>
            <div>址</div>
          </div>
          <div>{{ model.company_address }}</div>
        </div>
        <div class="bill_content">
          <div>
            <div>联</div>
            <div>系</div>
            <div>电</div>
            <div>话</div>
          </div>
          <div>{{ model.company_tel }}</div>
        </div>
        <div class="bill_content">
          <div>
            <div>开</div>
            <div>户</div>
            <div>银</div>
            <div>行</div>
          </div>
          <div>{{ model.bank }}</div>
        </div>
        <div class="bill_content">
          <div>
            <div>银</div>
            <div>行</div>
            <div>账</div>
            <div>户</div>
          </div>
          <div>{{ model.bank_no }}</div>
        </div>
        <el-divider v-if="model.qr"></el-divider>
        <div class="bill_content_qr" v-if="model.qr">
          <div>
            <img
              style="width: 200px; height: 200px"
              :src="'data:image/jepg;base64,' + model.qr"
            />
          </div>
        </div>
      </div>
    </el-dialog>
    <eco-sidebar-dialog
    destroy-on-close
      width="28%"
      title="法人机构"
      class="sp-manager__dialog"
      :visible="dialogVisible"
      :before-close="beforeCloseDialog"
      append-to-body
    >
      <el-form :model="model" ref="formName" data-vv-scope="propertyForm" style="padding: 20px">
        <el-form-item
          label="法人机构编号"
          label-width="120px"
          prop="corporate_no"
          :rules="{
            required: true, message: '必填', trigger: 'blur'
          }">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.corporate_no"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="公司名称" label-width="120px">-->
<!--          <eco-input v-model="model.company_name" validate="required" maxlength="200"/>-->
<!--        </eco-form-item>-->
        <el-form-item
          label="公司名称"
          label-width="120px"
          prop="company_name"
          :rules="{
            required: true, message: '必填', trigger: 'blur'
          }">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.company_name"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="税号" label-width="120px">-->
<!--          <eco-input v-model="model.tax_no" maxlength="200"/>-->
<!--        </eco-form-item>-->
        <el-form-item
          label="税号"
          label-width="120px"
          prop="tax_no"
        >
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.tax_no"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="联系电话" label-width="120px">-->
<!--          <eco-input v-model="model.company_tel" maxlength="200"/>-->
<!--        </eco-form-item>-->
        <el-form-item
          label="联系电话"
          label-width="120px"
          prop="company_tel"
        >
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.company_tel"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="开户银行" label-width="120px">-->
<!--          <eco-input v-model="model.bank" maxlength="200" />-->
<!--        </eco-form-item>-->
        <el-form-item
          label="开户银行"
          label-width="120px"
          prop="bank"
        >
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.bank"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="账号" label-width="120px">-->
<!--          <eco-input v-model="model.bank_no" maxlength="200" />-->
<!--        </eco-form-item>-->
        <el-form-item
          label="账号"
          label-width="120px"
          prop="bank_no"
          >
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.bank_no"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="单位地址" label-width="120px">-->
<!--          <eco-input v-model="model.company_address" maxlength="200" validate="required" />-->
<!--        </eco-form-item>-->
        <el-form-item
          label="单位地址"
          label-width="120px"
          prop="company_address"
          :rules="{
            required: true, message: '必填', trigger: 'blur'
          }"
        >
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.company_address"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="法定代表人" label-width="120px">-->
<!--          <eco-input v-model="model.corporate_person" maxlength="200" validate="required" />-->
<!--        </eco-form-item>-->
        <el-form-item
          label="法定代表人"
          label-width="120px"
          prop="corporate_person"
          :rules="{
            required: true, message: '必填', trigger: 'blur'
          }">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="model.corporate_person"
            maxlength="200"
            style="width:90%"
          />
        </el-form-item>
<!--        <eco-form-item label="是否默认" label-width="120px" maxlength="200">-->
<!--          <eco-radio-->
<!--            v-model="model.default"-->
<!--            :options="[-->
<!--              { key: 1, value: '是' },-->
<!--              { key: 0, value: '否' }-->
<!--            ]"-->
<!--          />-->
<!--        </eco-form-item>-->
        <el-form-item
          label="是否默认"
          label-width="120px"
          prop="default"
          :rules="{
            required: true, message: '必填', trigger: 'blur'
          }">
          <el-radio-group v-model="model.default">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="beforeCloseDialog">{{
          $t("eip.common.cancel")
        }}</el-button>
        <el-button type="primary" @click="afterSaveData">{{ $t("eip.common.save") }}</el-button>
<!--        <fe-submit-button-->
<!--          :url="saveUrl"-->
<!--          :model="model"-->
<!--          :request-method="saveMethod"-->
<!--          scope-name="propertyForm"-->
<!--          @after-save-data="afterSaveData"-->
<!--          >{{ $t("eip.common.save") }}</fe-submit-button-->
<!--        >-->
        
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
import portal from "@/api/portal.js";
import req from "@/request";

export default {
  props: {
    tenantId: String
  },
  data() {
    return {
      dialogVisible: false,
      dialogBillVisible: false,
      saveUrl:
        "${portal}/system/tenant_corporate_info/?tenantId=" + this.tenantId,
      budget_manager: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      model: {
        default: 0
      },
      isView: true,
      isEdit: false,
      saveMethod: "POST",
      maxHeight: document.body.clientHeight - 180,
      formConfig: {},
      formList: []
    };
  },
  mounted() {
    // this.$refs.htTable.doLayout();
    // this.$validator = this.$root.$validator;
  },
  methods: {
    showBillInfo(row) {
      if (row.id) {
        portal.getTenantCorporateQrCode(row.id).then(response => {
          this.dialogBillVisible = true;
          this.model = response;
        });
      } else {
        this.dialogBillVisible = false;
      }
    },
    showDialog(id) {
      if (id) {
        this.saveMethod = "PUT";
        this.isEdit = true;
        portal.getTenantCorporateInfo(id).then(response => {
          this.model = response;
          this.dialogVisible = true;
        });
      } else {
        this.saveMethod = "POST";
        this.isEdit = false;
        this.dialogVisible = true;
      }
    },
    beforeCloseDialog() {
      this.dialogVisible = false;
      this.model = {
        default: 0
      };
    },
    loadData(param, cb) {
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        };
        sessionStorage.setItem("corporateLoadJSON", JSON.stringify(obj));
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem("corporateLoadJSON"));
        param = session.param;
        cb = session.cb;
      }
      if (this.tenantId) {
        this.$http
          .post(
            "${portal}/system/tenant_corporate_info/query?tenantId=" +
              this.tenantId,
            param
          )
          .then(
            resp => {
              let response = resp.data;
              let res = response.rows;
              res.forEach(item => {
                item.f_id = item.id;
                item.f_ref_id = item.ref_id;
                item.f_corporate_no = item.corporate_no;
                item.f_company_name = item.company_name;
                item.f_tax_no = item.tax_no;
                item.F_company_tel = item.company_tel;
                item.F_bank_no = item.bank_no;
                item.f_company_address = item.company_address;
                item.f_corporate_person = item.corporate_person;
                item.f_default = item.default;
              });
              this.budget_manager = response.rows;
              this.pageResult = {
                page: response.page,
                pageSize: response.pageSize,
                total: response.total
              };
            },
            error => {
              reject(error);
            }
          )
          .finally(() => cb());
      } else {
        this.budget_manager = [];
        this.pageResult = {
          page: 1,
          pageSize: 50,
          total: 0
        };
      }
    },
    afterSaveData() {
      this.$refs['formName'].validate((valid) => {
        if (valid) {
          this.doSubmit();
        } else {
          console.log('失败');
          return false;
        }
      });
      // setTimeout(() => {
      //   this.beforeCloseDialog();
      //   this.$refs.htTable.load();
      // }, 500);
    },
    doSubmit() {
      let response = req
        .request({
          data: this.model,
          url: this.saveUrl,
          method: this.saveMethod
        })
        .then(req => {
          if(req.data.state){
            setTimeout(() => {
              this.$message.success("操作成功");
              this.beforeCloseDialog();
              this.$refs.htTable.load();
            }, 500);
          } else {
            this.$message.error(response.data.message);
          }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.companyName {
  font-size: 18px;
  font-weight: bold;
}
.bill {
  margin: 0 20px;
  .bill_content {
    display: flex;
    margin-bottom: 20px;
    > div:first-child {
      width: 60px;
      margin-right: 40px;
      display: inline-flex;
      justify-content: space-between;
      color: #868282;
    }
    > div:last-child {
      flex: 1;
      color: #000000;
    }
  }
  .bill_content_qr {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
#Manager {
}
.sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
  height: calc(100% - 170px);
}

.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
</style>
